<template>
    <article
        class="starRate"
        ref="starRatePopup">
        <button
            @click.prevent="hideRating"
            class="starRate__close"
            type="button"></button>
        <form
            class="starRate__form"
            id="starRateForm"
            ref="starRateForm">
            <input :value="reportCode" type="hidden" name="report_code" />
            <div
                class="starRate__raiting"
                ref="raiting">
                <legend class="starRate__caption">Насколько был полезен отчет?</legend>
                <fieldset class="starRate__fieldset" :data-value="rate">
                    <div class="starRate__field">
                        <input
                            class="visually-hidden"
                            @change="submitRate"
                            v-model="rate"
                            type="radio"
                            name="raiting"
                            value="5"
                            id="rate_5"/>
                        <label for="rate_5">
                            <svg
                                class="starRate__star"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 3.88129L13.4533 10.3633C12.9749 11.5809 11.8466 12.4326 10.5298 12.5444L3.6007 13.1324L9.02021 18.047C9.94724 18.8877 10.3451 20.1603 10.0716 21.3741L8.46279 28.514L14.1259 24.8521C15.2667 24.1145 16.7332 24.1145 17.8741 24.8521L23.5372 28.514L21.9284 21.3741C21.6549 20.1603 22.0528 18.8877 22.9798 18.047L28.3993 13.1324L21.4702 12.5444C20.1534 12.4326 19.0251 11.5809 18.5467 10.3633L16 3.88129ZM17.8331 1.25472C17.1759 -0.418241 14.8241 -0.418241 14.1668 1.25472L10.9713 9.38816C10.8612 9.66855 10.6027 9.86191 10.3043 9.88724L1.80855 10.6083C0.0885077 10.7543 -0.627779 12.8978 0.65481 14.0608L7.22886 20.0224C7.44102 20.2148 7.5333 20.5076 7.47013 20.788L5.49136 29.5698C5.10099 31.3023 6.99451 32.6389 8.47916 31.679L15.5739 27.0915C15.8335 26.9236 16.1665 26.9236 16.4261 27.0915L23.5208 31.679C25.0055 32.6389 26.899 31.3023 26.5086 29.5698L24.5299 20.788C24.4667 20.5076 24.559 20.2148 24.7711 20.0224L31.3452 14.0608C32.6278 12.8978 31.9115 10.7543 30.1915 10.6083L21.6957 9.88724C21.3973 9.86191 21.1388 9.66855 21.0287 9.38816L17.8331 1.25472Z" fill="#82BF00"/>
                            </svg>
                            <svg
                                class="starRate__star-fill"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.8331 1.25472C17.1759 -0.418241 14.8241 -0.418241 14.1668 1.25472L10.9713 9.38816C10.8612 9.66855 10.6027 9.86191 10.3043 9.88724L1.80855 10.6083C0.0885077 10.7543 -0.627779 12.8978 0.65481 14.0608L7.22886 20.0224C7.44102 20.2148 7.5333 20.5076 7.47013 20.788L5.49136 29.5698C5.10099 31.3023 6.99451 32.6389 8.47916 31.679L15.5739 27.0915C15.8335 26.9236 16.1665 26.9236 16.4261 27.0915L23.5208 31.679C25.0055 32.6389 26.899 31.3023 26.5086 29.5698L24.5299 20.788C24.4667 20.5076 24.559 20.2148 24.7711 20.0224L31.3452 14.0608C32.6278 12.8978 31.9115 10.7543 30.1915 10.6083L21.6957 9.88724C21.3973 9.86191 21.1388 9.66855 21.0287 9.38816L17.8331 1.25472Z" fill="#82BF00"/>
                            </svg>
                        </label>
                    </div>
                    <div class="starRate__field">
                        <input
                            class="visually-hidden"
                            @change="submitRate"
                            v-model="rate"
                            type="radio"
                            name="raiting"
                            value="4"
                            id="rate_4"/>
                        <label for="rate_4">
                            <svg
                                class="starRate__star"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 3.88129L13.4533 10.3633C12.9749 11.5809 11.8466 12.4326 10.5298 12.5444L3.6007 13.1324L9.02021 18.047C9.94724 18.8877 10.3451 20.1603 10.0716 21.3741L8.46279 28.514L14.1259 24.8521C15.2667 24.1145 16.7332 24.1145 17.8741 24.8521L23.5372 28.514L21.9284 21.3741C21.6549 20.1603 22.0528 18.8877 22.9798 18.047L28.3993 13.1324L21.4702 12.5444C20.1534 12.4326 19.0251 11.5809 18.5467 10.3633L16 3.88129ZM17.8331 1.25472C17.1759 -0.418241 14.8241 -0.418241 14.1668 1.25472L10.9713 9.38816C10.8612 9.66855 10.6027 9.86191 10.3043 9.88724L1.80855 10.6083C0.0885077 10.7543 -0.627779 12.8978 0.65481 14.0608L7.22886 20.0224C7.44102 20.2148 7.5333 20.5076 7.47013 20.788L5.49136 29.5698C5.10099 31.3023 6.99451 32.6389 8.47916 31.679L15.5739 27.0915C15.8335 26.9236 16.1665 26.9236 16.4261 27.0915L23.5208 31.679C25.0055 32.6389 26.899 31.3023 26.5086 29.5698L24.5299 20.788C24.4667 20.5076 24.559 20.2148 24.7711 20.0224L31.3452 14.0608C32.6278 12.8978 31.9115 10.7543 30.1915 10.6083L21.6957 9.88724C21.3973 9.86191 21.1388 9.66855 21.0287 9.38816L17.8331 1.25472Z" fill="#82BF00"/>
                            </svg>
                            <svg
                                class="starRate__star-fill"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.8331 1.25472C17.1759 -0.418241 14.8241 -0.418241 14.1668 1.25472L10.9713 9.38816C10.8612 9.66855 10.6027 9.86191 10.3043 9.88724L1.80855 10.6083C0.0885077 10.7543 -0.627779 12.8978 0.65481 14.0608L7.22886 20.0224C7.44102 20.2148 7.5333 20.5076 7.47013 20.788L5.49136 29.5698C5.10099 31.3023 6.99451 32.6389 8.47916 31.679L15.5739 27.0915C15.8335 26.9236 16.1665 26.9236 16.4261 27.0915L23.5208 31.679C25.0055 32.6389 26.899 31.3023 26.5086 29.5698L24.5299 20.788C24.4667 20.5076 24.559 20.2148 24.7711 20.0224L31.3452 14.0608C32.6278 12.8978 31.9115 10.7543 30.1915 10.6083L21.6957 9.88724C21.3973 9.86191 21.1388 9.66855 21.0287 9.38816L17.8331 1.25472Z" fill="#82BF00"/>
                            </svg>
                        </label>
                    </div>
                    <div class="starRate__field">
                        <input
                            class="visually-hidden"
                            @change="submitRate"
                            v-model="rate"
                            type="radio"
                            name="raiting"
                            value="3"
                            id="rate_3"/>
                        <label for="rate_3">
                            <svg
                                class="starRate__star"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 3.88129L13.4533 10.3633C12.9749 11.5809 11.8466 12.4326 10.5298 12.5444L3.6007 13.1324L9.02021 18.047C9.94724 18.8877 10.3451 20.1603 10.0716 21.3741L8.46279 28.514L14.1259 24.8521C15.2667 24.1145 16.7332 24.1145 17.8741 24.8521L23.5372 28.514L21.9284 21.3741C21.6549 20.1603 22.0528 18.8877 22.9798 18.047L28.3993 13.1324L21.4702 12.5444C20.1534 12.4326 19.0251 11.5809 18.5467 10.3633L16 3.88129ZM17.8331 1.25472C17.1759 -0.418241 14.8241 -0.418241 14.1668 1.25472L10.9713 9.38816C10.8612 9.66855 10.6027 9.86191 10.3043 9.88724L1.80855 10.6083C0.0885077 10.7543 -0.627779 12.8978 0.65481 14.0608L7.22886 20.0224C7.44102 20.2148 7.5333 20.5076 7.47013 20.788L5.49136 29.5698C5.10099 31.3023 6.99451 32.6389 8.47916 31.679L15.5739 27.0915C15.8335 26.9236 16.1665 26.9236 16.4261 27.0915L23.5208 31.679C25.0055 32.6389 26.899 31.3023 26.5086 29.5698L24.5299 20.788C24.4667 20.5076 24.559 20.2148 24.7711 20.0224L31.3452 14.0608C32.6278 12.8978 31.9115 10.7543 30.1915 10.6083L21.6957 9.88724C21.3973 9.86191 21.1388 9.66855 21.0287 9.38816L17.8331 1.25472Z" fill="#82BF00"/>
                            </svg>
                            <svg
                                class="starRate__star-fill"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.8331 1.25472C17.1759 -0.418241 14.8241 -0.418241 14.1668 1.25472L10.9713 9.38816C10.8612 9.66855 10.6027 9.86191 10.3043 9.88724L1.80855 10.6083C0.0885077 10.7543 -0.627779 12.8978 0.65481 14.0608L7.22886 20.0224C7.44102 20.2148 7.5333 20.5076 7.47013 20.788L5.49136 29.5698C5.10099 31.3023 6.99451 32.6389 8.47916 31.679L15.5739 27.0915C15.8335 26.9236 16.1665 26.9236 16.4261 27.0915L23.5208 31.679C25.0055 32.6389 26.899 31.3023 26.5086 29.5698L24.5299 20.788C24.4667 20.5076 24.559 20.2148 24.7711 20.0224L31.3452 14.0608C32.6278 12.8978 31.9115 10.7543 30.1915 10.6083L21.6957 9.88724C21.3973 9.86191 21.1388 9.66855 21.0287 9.38816L17.8331 1.25472Z" fill="#82BF00"/>
                            </svg>
                        </label>
                    </div>
                    <div class="starRate__field">
                        <input
                            class="visually-hidden"
                            @change="submitRate"
                            v-model="rate"
                            type="radio"
                            name="raiting"
                            value="2"
                            id="rate_2"/>
                        <label for="rate_2">
                            <svg
                                class="starRate__star"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 3.88129L13.4533 10.3633C12.9749 11.5809 11.8466 12.4326 10.5298 12.5444L3.6007 13.1324L9.02021 18.047C9.94724 18.8877 10.3451 20.1603 10.0716 21.3741L8.46279 28.514L14.1259 24.8521C15.2667 24.1145 16.7332 24.1145 17.8741 24.8521L23.5372 28.514L21.9284 21.3741C21.6549 20.1603 22.0528 18.8877 22.9798 18.047L28.3993 13.1324L21.4702 12.5444C20.1534 12.4326 19.0251 11.5809 18.5467 10.3633L16 3.88129ZM17.8331 1.25472C17.1759 -0.418241 14.8241 -0.418241 14.1668 1.25472L10.9713 9.38816C10.8612 9.66855 10.6027 9.86191 10.3043 9.88724L1.80855 10.6083C0.0885077 10.7543 -0.627779 12.8978 0.65481 14.0608L7.22886 20.0224C7.44102 20.2148 7.5333 20.5076 7.47013 20.788L5.49136 29.5698C5.10099 31.3023 6.99451 32.6389 8.47916 31.679L15.5739 27.0915C15.8335 26.9236 16.1665 26.9236 16.4261 27.0915L23.5208 31.679C25.0055 32.6389 26.899 31.3023 26.5086 29.5698L24.5299 20.788C24.4667 20.5076 24.559 20.2148 24.7711 20.0224L31.3452 14.0608C32.6278 12.8978 31.9115 10.7543 30.1915 10.6083L21.6957 9.88724C21.3973 9.86191 21.1388 9.66855 21.0287 9.38816L17.8331 1.25472Z" fill="#82BF00"/>
                            </svg>
                            <svg
                                class="starRate__star-fill"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.8331 1.25472C17.1759 -0.418241 14.8241 -0.418241 14.1668 1.25472L10.9713 9.38816C10.8612 9.66855 10.6027 9.86191 10.3043 9.88724L1.80855 10.6083C0.0885077 10.7543 -0.627779 12.8978 0.65481 14.0608L7.22886 20.0224C7.44102 20.2148 7.5333 20.5076 7.47013 20.788L5.49136 29.5698C5.10099 31.3023 6.99451 32.6389 8.47916 31.679L15.5739 27.0915C15.8335 26.9236 16.1665 26.9236 16.4261 27.0915L23.5208 31.679C25.0055 32.6389 26.899 31.3023 26.5086 29.5698L24.5299 20.788C24.4667 20.5076 24.559 20.2148 24.7711 20.0224L31.3452 14.0608C32.6278 12.8978 31.9115 10.7543 30.1915 10.6083L21.6957 9.88724C21.3973 9.86191 21.1388 9.66855 21.0287 9.38816L17.8331 1.25472Z" fill="#82BF00"/>
                            </svg>
                        </label>
                    </div>
                    <div class="starRate__field">
                        <input
                            class="visually-hidden"
                            @change="submitRate"
                            v-model="rate"
                            type="radio"
                            name="raiting"
                            value="1"
                            id="rate_1"/>
                        <label for="rate_1">
                            <svg
                                class="starRate__star"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 3.88129L13.4533 10.3633C12.9749 11.5809 11.8466 12.4326 10.5298 12.5444L3.6007 13.1324L9.02021 18.047C9.94724 18.8877 10.3451 20.1603 10.0716 21.3741L8.46279 28.514L14.1259 24.8521C15.2667 24.1145 16.7332 24.1145 17.8741 24.8521L23.5372 28.514L21.9284 21.3741C21.6549 20.1603 22.0528 18.8877 22.9798 18.047L28.3993 13.1324L21.4702 12.5444C20.1534 12.4326 19.0251 11.5809 18.5467 10.3633L16 3.88129ZM17.8331 1.25472C17.1759 -0.418241 14.8241 -0.418241 14.1668 1.25472L10.9713 9.38816C10.8612 9.66855 10.6027 9.86191 10.3043 9.88724L1.80855 10.6083C0.0885077 10.7543 -0.627779 12.8978 0.65481 14.0608L7.22886 20.0224C7.44102 20.2148 7.5333 20.5076 7.47013 20.788L5.49136 29.5698C5.10099 31.3023 6.99451 32.6389 8.47916 31.679L15.5739 27.0915C15.8335 26.9236 16.1665 26.9236 16.4261 27.0915L23.5208 31.679C25.0055 32.6389 26.899 31.3023 26.5086 29.5698L24.5299 20.788C24.4667 20.5076 24.559 20.2148 24.7711 20.0224L31.3452 14.0608C32.6278 12.8978 31.9115 10.7543 30.1915 10.6083L21.6957 9.88724C21.3973 9.86191 21.1388 9.66855 21.0287 9.38816L17.8331 1.25472Z" fill="#82BF00"/>
                            </svg>
                            <svg
                                class="starRate__star-fill"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.8331 1.25472C17.1759 -0.418241 14.8241 -0.418241 14.1668 1.25472L10.9713 9.38816C10.8612 9.66855 10.6027 9.86191 10.3043 9.88724L1.80855 10.6083C0.0885077 10.7543 -0.627779 12.8978 0.65481 14.0608L7.22886 20.0224C7.44102 20.2148 7.5333 20.5076 7.47013 20.788L5.49136 29.5698C5.10099 31.3023 6.99451 32.6389 8.47916 31.679L15.5739 27.0915C15.8335 26.9236 16.1665 26.9236 16.4261 27.0915L23.5208 31.679C25.0055 32.6389 26.899 31.3023 26.5086 29.5698L24.5299 20.788C24.4667 20.5076 24.559 20.2148 24.7711 20.0224L31.3452 14.0608C32.6278 12.8978 31.9115 10.7543 30.1915 10.6083L21.6957 9.88724C21.3973 9.86191 21.1388 9.66855 21.0287 9.38816L17.8331 1.25472Z" fill="#82BF00"/>
                            </svg>
                        </label>
                    </div>
                </fieldset>
                <div
                    class="starRate__error-wrap"
                    v-if="errorRecapcha.error || errorResponse.error">
                    <span
                        v-if="errorRecapcha.error"
                        class="starRate__error"
                        v-html="errorRecapcha.text"></span>
                    <span
                        v-if="errorResponse.error"
                        class="starRate__error"
                        v-html="errorResponse.text"></span>
                </div>
            </div>
            <div
                class="starRate__wrapper"
                ref="textarea">
                <textarea
                    v-model="text"
                    class="starRate__textarea"
                    name="comment"
                    placeholder="Напишите, что хотелось бы улучшить"
                    maxlength="300"
                    @input="checkValueLength">
                </textarea>
                <button
                    v-if="showClearBtn"
                    class="starRate__clear"
                    aria-label="Отчистить поле"
                    @click.prevent="clearTextarea">
                </button>
                <div ref="smartcaptcha"></div>
                <button
                    class="starRate__submit"
                    @click.prevent="onSubmit">
                    Отправить
                </button>
            </div>
        </form>
        <div
            class="starRate__submited"
            ref="submited">
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0525 3.14457C11.5752 2.48633 9.92468 2.32326 8.34712 2.67968C6.76957 3.03611 5.3495 3.89294 4.29869 5.12238C3.24789 6.35182 2.62265 7.888 2.51624 9.50181C2.40982 11.1156 2.82793 12.7206 3.7082 14.0774C4.58847 15.4341 5.88374 16.47 7.40083 17.0305C8.91792 17.591 10.5756 17.6461 12.1265 17.1875C13.6774 16.7289 15.0386 15.7813 16.007 14.4859C16.9754 13.1906 17.4991 11.6169 17.5 9.99957V9.23338C17.5 8.77315 17.8731 8.40005 18.3333 8.40005C18.7936 8.40005 19.1667 8.77315 19.1667 9.23338V10.0001C19.1655 11.9768 18.5254 13.9006 17.3419 15.4839C16.1583 17.0671 14.4947 18.2253 12.5991 18.7858C10.7035 19.3462 8.67747 19.2789 6.82324 18.5939C4.96902 17.9089 3.38591 16.6428 2.31003 14.9845C1.23414 13.3262 0.723122 11.3646 0.853183 9.39215C0.983245 7.41971 1.74742 5.54216 3.03174 4.03951C4.31605 2.53686 6.0517 1.48963 7.97982 1.05399C9.90794 0.618361 11.9252 0.817669 13.7308 1.62219C14.1512 1.80951 14.3402 2.30216 14.1528 2.72255C13.9655 3.14294 13.4729 3.33189 13.0525 3.14457ZM18.9223 2.74383C19.2479 3.06911 19.2481 3.59675 18.9229 3.92234L10.5895 12.264C10.4333 12.4204 10.2213 12.5083 10.0002 12.5084C9.77911 12.5084 9.56706 12.4206 9.41073 12.2643L6.91073 9.76431C6.58529 9.43887 6.58529 8.91123 6.91073 8.5858C7.23617 8.26036 7.7638 8.26036 8.08924 8.5858L9.99969 10.4962L17.7438 2.74442C18.069 2.41882 18.5967 2.41856 18.9223 2.74383Z" fill="#97CB53"/>
            </svg>
            <p  class="starRate__desc">
                Спасибо за обратную связь!
            </p>
        </div>
    </article>
</template>

<script>
    import axios from 'axios'
    import captchaMixin from '@/js/vue-components/mixins/captcha';

    export default {
        name: 'StarRate',
	      mixins: [captchaMixin],
        props: {
            reportCode: String,
        },
        data() {
            return {
                apiUrl: '/api/v2/service/page-rating/vote/',
                rate: null,
                text: '',
                hash: '',
                formId: '',
                showClearBtn: false,
                currentHeight: null,
                errorRecapcha: {
                    error: false,
                    text: 'Пожалуйста повторите отправку.',
                },
                errorResponse: {
                    error: false,
                    text: 'При отправке произошла ошибка. Пожалуйста, перезагрузите страницу и повторите отправку.',
                },
	              captchaId: null
            }
        },

        methods: {
            submitRate () {
                this.errorRecapcha.error = false
                this.errorResponse.error = false
                this.setFormHeightDown()

                //- вызывает из ./mixins/captcha
	              this.initCaptcha();
            },

            submitFormAfterCaptchaCheck() {
              let formData = new FormData(starRateForm)
              if (this.hash) {
                formData.append('hash', this.hash)
              }
              if (this.formId) {
                formData.append('id', this.formId)
              }
              axios({
                method: 'post',
                url: this.apiUrl,
                data: formData
              })
                .then((response) => {
                  if (response.data.success) {
                    this.$refs.textarea.style.height = `${this.$refs.textarea.scrollHeight}px`
                    this.setFormHeightUp()

                    this.hash = response.data.hash
                    this.formId = response.data.id

                    setTimeout(() => {
                      if (!this.text) {
                        this.hideRating()
                      }
                    }, 30000)
                    return
                  }

                  this.errorResponse.error = true
                  this.setFormHeightUp()
                })
                .catch((error) => {
                  this.errorResponse.error = true
                  this.setFormHeightUp()
                })
            },

            onSubmit () {
                this.errorRecapcha.error = false
                this.errorResponse.error = false
                this.setFormHeightDown()

                if (this.validateTextarea()) {
	                  this.initCaptcha(this.submitFormAfterSecondCaptchaCheck);
                } else {
                    this.errorRecapcha.text = 'Пожалуйста оставьте комментарий'
                    this.errorRecapcha.error = true
                    this.setFormHeightUp()
                }
            },

	          submitFormAfterSecondCaptchaCheck() {
		          let formData = new FormData(starRateForm)
		          if (this.hash) {
			          formData.append('hash', this.hash)
		          }
		          if (this.formId) {
			          formData.append('id', this.formId)
		          }
		          axios({
			          method: 'post',
			          url: this.apiUrl,
			          data: formData
		          })

		          this.$refs.starRateForm.style.height = '0px'
		          setTimeout(() => {
			          this.$refs.submited.style.height = '20px'
		          }, 300);

		          this.$refs.starRateForm.style.pointerEvents = 'none'
		          setTimeout(() => {
			          this.hideRating()
		          }, 10000)
	          },

            setFormHeightUp () {
                setTimeout(() => {
                    this.$refs.starRateForm.style.height = `${this.$refs.starRateForm.scrollHeight}px`
                }, 0)
            },

            setFormHeightDown () {
                setTimeout(() => {
                    this.$refs.starRateForm.style.height = `${this.$refs.raiting.scrollHeight + this.$refs.textarea.scrollHeight}px`
                }, 0)
            },

            showRating () {
                setTimeout(() => {
                    this.$refs.starRatePopup.style.display = 'block'
                    this.setFormHeightUp()
                    this.$refs.starRatePopup.classList.add('active')
                }, 15000)
            },

            hideRating () {
                document.cookie = `${this.reportCode}=${this.reportCode}`
                this.$refs.starRatePopup.classList.remove('active')
                setTimeout(() => {
                    this.$refs.starRatePopup.style.display = 'none'
                }, 300)
            },

            validateTextarea () {
                const pattern = /^[\s]+$/
                if (this.text.length === 0 || pattern.test(this.text)) {
                    return false
                }

                return true
            },

            clearTextarea () {
                this.text = ''
                this.checkValueLength()
            },
            
            checkValueLength () {
                this.errorRecapcha.error = false
                this.errorResponse.error = false
                this.setFormHeightDown()
               
                if (this.text.length !== 0) {
                    this.showClearBtn = true
                    return
                }

                this.showClearBtn = false
            },

            getCookie(name) {
                let matches = document.cookie.match(new RegExp(
                    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
                ));
                return matches ? decodeURIComponent(matches[1]) : undefined;
            },
        },

        mounted() {
           if (this.getCookie(this.reportCode) !== this.reportCode) this.showRating()
        }
    }
</script>